define([
    'jquery'
], function($){
    "use strict";

    var PLUGIN_NAME = "dragSlider";
    var PLUGIN_VERSION = "v0.1";

    var	DEFAULTS = {
        controlButtonsClass: {
            left: '',
            right: ''
        },
        resolutions : {
            xxl: { res: 1600, items: 4},
            lg:	{ res: 1200, items: 3},
            md:	{ res: 1024, items: 3},
            sm: { res: 768, items: 2},
            xs: { res: 480, items: 2}
        },
        callback: null
    };

    // The actual plugin constructor
    var CustomDragSlider = function ( element, options ) {
        this.element = element;
        this.options = $.extend(true, {}, DEFAULTS, options );
        this.defaults_ = DEFAULTS;
        this.initialise();
    };

    /**
     * init function
     */
    CustomDragSlider.prototype.initialise = function() {
        this.$ul = $('ol:first', $(this.element));
        this.$liList = $('>li', this.$ul);
        this.$wrapper = null;
        this.ulWidth = 0;
        this.liWidth = 0;
        this.liWidthOuter = 0;
        this.wrapperWidth = 0;
        this.itemsToMove = 1;

        if (this.$liList.size() == 0) { return false; }

        this.setDimensions();
        if (!this.recalcDimensions()) {
            return false;
        }
        this.renderControlButtons();
        this.updateControlButtons();

        if ($.isFunction(this.options.callback)) {
            this.options.callback.call(this);
        }

        var self_ = this;

        if (this.isTouchDevice()) {
            window.addEventListener("orientationchange", function () {
                self_.recalcDimensions();
            }, false);
        } else {
            $(window).bind('resize', function() {
                self_.recalcDimensions();
            });
        }


    };

    /**
     *  get list width, get container width, render wrapper
     */
    CustomDragSlider.prototype.setDimensions = function() {
        var self_ = this;

        // make the wrapper up
        this.$ul.wrap('<div class="dragsliderWrapper"></div>');
        this.$wrapper = this.$ul.parents('.dragsliderWrapper:first');
        this.$wrapper.css({ 'overflow-x': 'hidden', 'overflow-y': 'hidden' });

        // for sure - set LI same width
        this.liWidth = $(this.$liList[0]).width();
        this.liWidthOuter = $(this.$liList[0]).outerWidth(true);
        this.$liList.each(function() {
            $(this).width(self_.liWidth);
        });

        // make all LIs to fit in one UL row
        this.ulWidth = this.$liList.size()*$(this.$liList[0]).outerWidth(true);
        this.$ul.width(this.ulWidth);
    };

    /**
     * find if control buttons is needed, recalc animate offset
     */
    CustomDragSlider.prototype.recalcDimensions = function() {
        this.wrapperWidth = this.$wrapper.width();

        /*if ($.isArray(this.controls)) {
            this.controls[0].show();
            this.controls[1].show();
        }*/

        var width = $(window).width();
        if (width >= this.options.resolutions.sm.res) { this.itemsToMove = this.options.resolutions.sm.items; }
        if (width >= this.options.resolutions.md.res) { this.itemsToMove = this.options.resolutions.md.items; }
        if (width >= this.options.resolutions.lg.res) { this.itemsToMove = this.options.resolutions.lg.items; }
        if (width >= this.options.resolutions.xxl.res) { this.itemsToMove = this.options.resolutions.xxl.items; }

        this.$ul.css({
            'margin-left': '0px'
        });

        if ($.isArray(this.controls)) {
            this.updateControlButtons();
        }

        return true;
    };

    /**
     * create arrows
     */
    CustomDragSlider.prototype.renderControlButtons = function() {

        this.controls = [];
        this.controls.push($('<span class="controlButton prev '+ this.options.controlButtonsClass.left+'"></span>'));
        this.controls.push($('<span class="controlButton next '+ this.options.controlButtonsClass.right+'"></span>'));
        $(this.element).append(this.controls[0]);
        $(this.element).append(this.controls[1]);

        this.bindControlButtons();
    };

    /**
     * let created arrows to do something
     */
    CustomDragSlider.prototype.bindControlButtons = function() {
        var self_ = this;

        this.controls[0].bind('click', function(e) {
            var $t = $(this);
            if ($t.hasClass('disabled') || e.which != 1) {
                return false;
            }
            self_.moveItems(self_.itemsToMove);
        });

        this.controls[1].bind('click', function(e) {
            var $t = $(this);
            if ($t.hasClass('disabled') || e.which != 1) {
                return false;
            }
            self_.moveItems(-1*self_.itemsToMove);
        });

    };

    /**
     * updates disabled status on buttons
     */
    CustomDragSlider.prototype.updateControlButtons = function() {
        var actualPosition = String(this.$ul.css('margin-left')).replace('px','');
        if (actualPosition == 0) {
            this.controls[0].addClass('disabled');
        } else {
            this.controls[0].removeClass('disabled');
        }
        if (actualPosition == this.wrapperWidth - this.ulWidth) {
            this.controls[1].addClass('disabled');
        } else {
            this.controls[1].removeClass('disabled');
        }
    };

    /**
     * animate slide
     */
    CustomDragSlider.prototype.moveItems = function(items) {
        var self_ = this;
        var widthToMove = items * this.liWidthOuter;

        var actualPosition = 1*(String(this.$ul.css('margin-left')).replace('px',''));
        var maxPosition = this.wrapperWidth - this.ulWidth;

        actualPosition += widthToMove;
        actualPosition = (actualPosition > 0) ? 0 : actualPosition;
        actualPosition = (actualPosition < maxPosition) ? maxPosition : actualPosition;

        this.$ul.animate({
            'margin-left': actualPosition + 'px'
        }, 400, function() {
            self_.updateControlButtons();
        });
    };

    CustomDragSlider.prototype.isTouchDevice = function() {
        try { document.createEvent("TouchEvent"); return true; }
        catch (e) { return false; }
    };


    /**
     * decide, which methods will be "public"
     */
    var API = {
    };

    /**
     * plugin go live
     * @param value - first param - decides, which action shall be executed
     * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
     * 		if string && in API object - run method named as this value with all args[index > 0]
     * @return {*}
     */
    $.fn[PLUGIN_NAME] = function (value) {
        var args = arguments;

        return this.each(function () {
            var $this = $(this);

            // get plugin instance
            var plugin = $this.data('plugin_' + PLUGIN_NAME);

            // if there's not, create one
            if (!plugin) {
                plugin = new CustomDragSlider(this, value);
                $this.data('plugin_' + PLUGIN_NAME, plugin);
            }
            // if there is and first parameter is in predefined API methods, call it with rest of params
            else if (API[value]) {
                plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
            }
        });
    };


    /**
     * setDefaults with $.googlemap.setDefaults();
     */
    $[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
    $[PLUGIN_NAME].setDefaults = function(newOptions) {
        DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
    };

});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.dragslider.js